import { IncomingTransferRequestDetailPage } from "@/features/transfer-request/pages/IncomingTransferRequestDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/admin/incoming-transfer-request/$id/detail"
)({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["transfer_request.view_incoming"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: IncomingTransferRequestDetailPage,
});
